export default __webpack_public_path__ + "static/IPad_App-MockUp-7b5e6b779278115f4df280c24ee9fcf9.png";